module.exports = __webpack_public_path__ + "static/media/Youtube.d4087ad7.svg";